import React, { useContext, useState, useEffect } from "react";
import { Row, Col, Card, Button, Table } from "react-bootstrap";
import classes from "./OrderReceipt.module.css";
import { Divider } from "rsuite";
import PermissionContext from "../../Store/permission-context";
const OrderReceipt = (props) => {
  const PCtx = useContext(PermissionContext);

  const [UnitTable, setUnitTable] = useState([]);
  const [BulkTable, setBulkTable] = useState([]);
  const [UnitBulkTable, setUnitBulkTable] = useState([]);
  const [Print, setPrint] = useState(false);
  const inWords = (number) => {
    var digit = [
      "Zero",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    var elevenSeries = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    var countingByTens = [
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    var shortScale = ["", "Thousand", "Million", "Billion", "Trillion"];

    number = number.toString();
    number = number.replace(/[\, ]/g, "");
    if (number != parseFloat(number)) return "Not a Number";
    var x = number.indexOf(".");
    if (x == -1) x = number.length;
    if (x > 15) return "Too Big";
    var n = number.split("");
    var str = "";
    var sk = 0;
    for (var i = 0; i < x; i++) {
      if ((x - i) % 3 == 2) {
        if (n[i] == "1") {
          str += elevenSeries[Number(n[i + 1])] + " ";
          i++;
          sk = 1;
        } else if (n[i] != 0) {
          str += countingByTens[n[i] - 2] + " ";
          sk = 1;
        }
      } else if (n[i] != 0) {
        str += digit[n[i]] + " ";
        if ((x - i) % 3 == 0) str += "hundred and ";
        sk = 1;
      }
      if ((x - i) % 3 == 1) {
        if (sk) str += shortScale[(x - i - 1) / 3] + " ";
        sk = 0;
      }
    }
    if (x != number.length) {
      var y = number.length;
      str += "point ";
      for (var i = x + 1; i < y; i++) str += digit[n[i]] + " ";
    }
    str = str.replace(/\number+/g, " ");

    str = str.trim() + " Naira";
    var right = "hundred Naira";
    var wrong = "hundred and Naira";
    str = str.indexOf(wrong) >= 0 ? str.replace(wrong, right) : str;
    return str;
  };

  useEffect(() => {
    let AllTable = props.Rct.OrderData;
    let AllUnit = [];
    let AllBulk = [];
    let AllUnitBulk = [];
    AllTable.forEach((order) => {
      if (order.nop < 1) {
        AllUnit.push(order);
      } else {
        if (order.nop >= 1 && order.nou === 0) {
          AllBulk.push(order);
        } else {
          if (order.nou > 0 && order.nop >= 1) {
            AllUnitBulk.push(order);
          }
        }
      }
    });
    setUnitTable(AllUnit);
    setBulkTable(AllBulk);
    setUnitBulkTable(AllUnitBulk);
    if (props.PrintDirectly) {
      setPrint(!Print);
    }
  }, [props.Rct.OrderData]);

  const FormatCurrency = (num) => {
    let Fm = Math.round(parseFloat(num)).toLocaleString("en-US");
    return Fm;
  };

  //   useEffect(() => {
  //     if (Print) {
  //       window.print();
  //     }
  //   }, [Print]);

  return (
    <Row
      className={classes.margin4printing}
      style={{ backgroundColor: "white" }}
    >
      <Col md={12} sm={12} className={classes.margin4printing}>
        <Row className={classes.hide4printing}>
          <Col md={12} sm={12}>
            <p className={classes.Company}>ALAGUSIY IDEKUN MARKET</p>
            <p className={classes.Address} style={{ fontStyle: "italic" }}>
              Wholesales & Retails
            </p>
            <p className={classes.Address}>
              Juniwad Filling Station, University Road, Beside Sawmill, Ilorin,
              Kwara State.
            </p>
            <p className={classes.Tel}>07016800278</p>
            <Divider style={{ margin: "10px", fontFamily: "Times New Roman" }}>
              PAYMENT RECEIPT
            </Divider>
          </Col>
        </Row>

        {props.Rct.ShowReceipt && (
          <Row className={classes.MyReceipt}>
            <Col md={12} sm={12}>
              <Row className="px-2">
                <Col md={12} sm={12} className={classes.ReceiptName}>
                  {props.Rct.cn}
                </Col>
                <Col md={12} sm={12} xs={7} className={classes.ON}>
                  No : {props.Rct.ON}
                </Col>
                <Col md={12} sm={12} xs={7} className={classes.ON}>
                  Total : ₦
                  {FormatCurrency(parseFloat(props.Rct.PayableWithDiscount))}
                </Col>

                <Col md={7} sm={7} xs={7} className={classes.ReceiptDetails}>
                  Date: {props.Rct.rdt}
                </Col>
                <Col md={5} sm={5} xs={5} className={classes.ReceiptDetails}>
                  Staff: {PCtx.Username}
                </Col>
              </Row>
            </Col>

            {/* Unit Only */}
            {UnitTable.length > 0 && (
              <Divider
                className={`${classes.myDivider} ${classes.hide4printing}`}
              >
                Unit Items Only
              </Divider>
            )}
            {UnitTable.length > 0 && (
              <Table
                bordered
                className={`${classes.TheTable} ${classes.hide4printing}`}
              >
                <thead>
                  <tr className={classes.TableData}>
                    <th className={classes.TableData}>SN</th>
                    <th className={classes.TableData}>Description</th>
                    <th className={classes.TableData}>Bulk Price</th>
                    <th className={classes.TableData}>Unit Price</th>
                    <th className={classes.TableData}>B/U</th>
                    <th className={classes.TableData}>Sub Total</th>
                  </tr>
                </thead>
                <tbody>
                  {UnitTable.map((order, index) => (
                    <tr key={index} className={classes.TableData}>
                      <td className={classes.TableData}>{index + 1}</td>
                      <td className={classes.TableData}>{order.description}</td>
                      <td className={classes.TableData}>
                        {isNaN(order.bulkprice) ? "-" : order.bulkprice}
                      </td>
                      <td className={classes.TableData}>
                        {isNaN(order.unitprice) ? "-" : order.unitprice}
                      </td>
                      <td className={classes.TableData}>{order.converter}</td>
                      <td className={classes.TableData}>{order.subtotal}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}

            {BulkTable.length > 0 && (
              <Col md={12} sm={12} className={classes.hide4printing}>
                <p>-----------------</p>
                <Divider className={classes.myDivider}>Bulk Items Only</Divider>
                <Row className="px-2">
                  <Col md={12} sm={12} className={classes.ReceiptName}>
                    Name: {props.Rct.cn}
                  </Col>
                  <Col md={7} sm={7} xs={7} className={classes.ReceiptDetails}>
                    Receipt No : {props.Rct.rcn}
                  </Col>
                  <Col md={5} sm={5} xs={5} className={classes.ReceiptDetails}>
                    Phone: {props.Rct.pn}
                  </Col>
                  <Col md={7} sm={7} xs={7} className={classes.ReceiptDetails}>
                    Date: {props.Rct.rdt}
                  </Col>
                  <Col md={5} sm={5} xs={5} className={classes.ReceiptDetails}>
                    Staff: {PCtx.Username}
                  </Col>
                </Row>
              </Col>
            )}
            {/* Bulk Only */}
            {BulkTable.length > 0 && (
              <Table
                bordered
                className={`${classes.TheTable} ${classes.hide4printing}`}
              >
                <thead>
                  <tr className={classes.TableData}>
                    <th className={classes.TableData}>SN</th>
                    <th className={classes.TableData}>Description</th>
                    <th className={classes.TableData}>Bulk Price</th>
                    <th className={classes.TableData}>Unit Price</th>
                    <th className={classes.TableData}>B/U</th>
                    <th className={classes.TableData}>Sub Total</th>
                  </tr>
                </thead>
                <tbody>
                  {BulkTable.map((order, index) => (
                    <tr key={index} className={classes.TableData}>
                      <td className={classes.TableData}>{index + 1}</td>
                      <td className={classes.TableData}>{order.description}</td>
                      <td className={classes.TableData}>{order.bulkprice}</td>
                      <td className={classes.TableData}>{order.unitprice}</td>
                      <td className={classes.TableData}>{order.converter}</td>
                      <td className={classes.TableData}>{order.subtotal}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
            {/* Bulk and Unit */}
            {UnitBulkTable.length > 0 && (
              <Col md={12} sm={12} className={classes.hide4printing}>
                <p>---------------------</p>
                <Divider className={classes.myDivider}>
                  Unit & Bulk Items Only
                </Divider>
                <Row className="px-2">
                  <Col md={12} sm={12} className={classes.ReceiptName}>
                    Name: {props.Rct.cn}
                  </Col>
                  <Col md={7} sm={7} xs={7} className={classes.ReceiptDetails}>
                    Receipt No : {props.Rct.rcn}
                  </Col>
                  <Col md={5} sm={5} xs={5} className={classes.ReceiptDetails}>
                    Phone: {props.Rct.pn}
                  </Col>
                  <Col md={7} sm={7} xs={7} className={classes.ReceiptDetails}>
                    Date: {props.Rct.rdt}
                  </Col>
                  <Col md={5} sm={5} xs={5} className={classes.ReceiptDetails}>
                    Staff: {PCtx.Username}
                  </Col>
                </Row>
              </Col>
            )}
            {UnitBulkTable.length > 0 && (
              <Table
                bordered
                className={`${classes.TheTable} ${classes.hide4printing}`}
              >
                <thead>
                  <tr className={classes.TableData}>
                    <th className={classes.TableData}>SN</th>
                    <th className={classes.TableData}>Description</th>
                    <th className={classes.TableData}>Bulk Price</th>
                    <th className={classes.TableData}>Unit Price</th>
                    <th className={classes.TableData}>B/U</th>
                    <th className={classes.TableData}>Sub Total</th>
                  </tr>
                </thead>
                <tbody>
                  {UnitBulkTable.map((order, index) => (
                    <tr key={index} className={classes.TableData}>
                      <td className={classes.TableData}>{index + 1}</td>
                      <td className={classes.TableData}>{order.description}</td>
                      <td className={classes.TableData}>{order.bulkprice}</td>
                      <td className={classes.TableData}>{order.unitprice}</td>
                      <td className={classes.TableData}>{order.converter}</td>
                      <td className={classes.TableData}>{order.subtotal}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}

            <Col md={12} sm={12} xs={12} className={classes.hide4printing}>
              {props.Rct.Discount > 0 && (
                <p className={classes.Discount}>{props.Rct.Discount} </p>
              )}
              <p className={classes.Total}>
                Total Amount Unpaid: ₦{props.Rct.PayableWithDiscount}
              </p>
              <p className={classes.Word}>
                {inWords(parseFloat(props.Rct.PayableWithDiscount))}
              </p>
              <Divider className="mr-1 my-1" />
            </Col>
            <Col md={12} sm={12} xs={12} className={classes.hide4printing}>
              <p className={classes.Word}>
                Goods sold in good condition are not returnable.
              </p>
              <p className={classes.Word}>Thanks for your patronage</p>
              <Divider className="mr-1 my-1" />
            </Col>
            <Col md={12} sm={12} xs={12} className={classes.hide4printing}>
              <p className={classes.Applause}>
                POS Software developed by: APPLAUSE INFOTECH | 08033824233
              </p>
            </Col>
          </Row>
        )}
      </Col>
      <Col
        md={12}
        sm={12}
        xs={12}
        className={`${classes.hide4printing} ${"mt-2"}`}
      ></Col>
    </Row>
  );
};

export default OrderReceipt;
